import { envBasics } from 'src/environments/dvds/basics';
import { Environment } from '../../app/environment';

export const environment: Environment = {
    ...envBasics,
    apiEndpoint: 'https://planning-acc.dvds.nl/api/',
    disableAfas: true,
    feEndpoint: 'https://planning-acc.dvds.nl/',
    dirkAppUrl: 'https://dirk-acc.dvds.nl/',
    production: true,
    test: true,
    titleAppend: ' - ACCEPTANCE - D. van der Steen B.V.',
    wsEndpoint: 'wss://planning-acc.dvds.nl/websocket/',
};
